<section class="p-4 flex flex-column gap-4">
  <h2 class="m-0">{{ 'lot_trace.title' | translate }}</h2>
  <div class="flex gap-2 align-items-center">
    <input pInputText class="w-20rem" [(ngModel)]="lotValue" [placeholder]="'lot_trace.placeholder' | translate" (keyup.enter)="search()" />
    <button pButton type="button" [label]="'lot_trace.search' | translate" [loading]="loading" (click)="search()"></button>
  </div>
  @if (searched && lots.length === 0) {
    <p>{{ 'lot_trace.empty' | translate }}</p>
  }
  @for (lot of lots; track lot.batchId) {
    <article class="border-1 border-round p-3 surface-card">
      <h3 class="mt-0">{{ lot.lotValue || lot.batchId }}</h3>
      <p class="m-0">{{ 'lot_trace.sku' | translate }}: {{ lot.skuCode }}</p>
      <p class="m-0">{{ 'lot_trace.warehouse' | translate }}: {{ lot.warehouseName || lot.warehouseId }}</p>
      <p class="m-0">{{ 'lot_trace.qty' | translate }}: {{ lot.qty }}</p>
      <p class="m-0">{{ 'lot_trace.source_type' | translate }}: {{ formatSourceType(lot.sourceType) }}</p>
      <p class="m-0">{{ 'lot_trace.inbound' | translate }}: {{ lot.sourceWarrantCode || '-' }}</p>
      <p class="m-0">{{ 'lot_trace.source' | translate }}: {{ lot.sourceRecordCode || '-' }}</p>
      <p class="m-0">{{ 'lot_trace.supplier' | translate }}: @if (lot.supplierMissing) { {{ 'lot_trace.supplier_missing' | translate }} } @else { {{ lot.supplierName || lot.supplierCode || '-' }} }</p>
      <p class="m-0">{{ 'lot_trace.first_received_at' | translate }}: {{ formatDateTime(lot.receivedAt) }}</p>
      <h4>{{ 'lot_trace.receipts' | translate }}</h4>
      @if (!lot.receipts?.length) {
        <p class="text-color-secondary">{{ 'lot_trace.receipts_empty' | translate }}</p>
      } @else {
        <p-table [value]="lot.receipts || []">
          <ng-template pTemplate="header"><tr>
            <th>{{ 'lot_trace.received_at' | translate }}</th>
            <th>{{ 'lot_trace.inbound' | translate }}</th>
            <th>{{ 'lot_trace.source_type' | translate }}</th>
            <th>{{ 'lot_trace.source' | translate }}</th>
            <th>{{ 'lot_trace.qty' | translate }}</th>
            <th>{{ 'lot_trace.supplier' | translate }}</th>
          </tr></ng-template>
          <ng-template pTemplate="body" let-row><tr>
            <td>{{ formatDateTime(row.receivedAt) }}</td>
            <td>{{ row.warrantCode || '-' }}</td>
            <td>{{ formatSourceType(row.sourceType) }}</td>
            <td>{{ row.sourceRecordCode || '-' }}</td>
            <td>{{ row.qtyReceived }}</td>
            <td>{{ row.supplierName || row.supplierCode || '-' }}</td>
          </tr></ng-template>
        </p-table>
      }
      <h4>{{ 'lot_trace.outbounds' | translate }}</h4>
      <p-table [value]="lot.outbounds || []">
        <ng-template pTemplate="header"><tr>
          <th>{{ 'lot_trace.outbound_code' | translate }}</th>
          <th>{{ 'lot_trace.order_code' | translate }}</th>
          <th>{{ 'lot_trace.warehouse' | translate }}</th>
          <th>{{ 'lot_trace.qty' | translate }}</th>
        </tr></ng-template>
        <ng-template pTemplate="body" let-row><tr>
          <td>{{ row.outboundCode }}</td>
          <td>{{ row.orderCode }}</td>
          <td>{{ row.warehouseName }}</td>
          <td>{{ row.qty }}</td>
        </tr></ng-template>
      </p-table>
    </article>
  }
  @if (orders.length > 0) {
    <article class="border-1 border-round p-3 surface-card">
      <h3 class="mt-0">{{ 'lot_trace.orders' | translate }}</h3>
      <p-table [value]="orders">
        <ng-template pTemplate="header"><tr>
          <th>{{ 'lot_trace.order_code' | translate }}</th>
          <th>{{ 'lot_trace.store' | translate }}</th>
          <th>{{ 'lot_trace.qty' | translate }}</th>
          <th>{{ 'lot_trace.serial' | translate }}</th>
        </tr></ng-template>
        <ng-template pTemplate="body" let-row><tr>
          <td>{{ row.orderCode }}</td>
          <td>{{ row.storeName }}</td>
          <td>{{ row.qty }}</td>
          <td>{{ row.serialNumber }}</td>
        </tr></ng-template>
      </p-table>
    </article>
  }
</section>